import { combineReducers } from 'redux'
import userReducer from './user/reducer'
import { addressReducer } from './address/reducer';
import loanReducer from './loan/reducer';
import cardReducer from './card/reducer';

const rootReducer = combineReducers({
    userReducer,
    addressReducer,
    loanReducer,
    cardReducer
});

export default rootReducer;